export default "__VITE_ASSET__BirtMURb__"